import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47b65d49"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  id: "slider",
  class: "w-[100%] h-[100vh]",
  ref: "sliderRef"
}
const _hoisted_3 = { class: "slider-inner" }
const _hoisted_4 = { id: "slider-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "meta" }, "Ciudades", -1))
const _hoisted_6 = {
  id: "slide-title",
  ref: "slideTitleRef"
}
const _hoisted_7 = ["data-slide-title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "meta" }, "Título", -1))
const _hoisted_9 = {
  id: "slide-status",
  ref: "slideStatusRef"
}
const _hoisted_10 = ["data-slide-status"]
const _hoisted_11 = {
  class: "images",
  ref: "imagesRef"
}
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  id: "pagination",
  ref: "paginationRef"
}
const _hoisted_14 = ["data-slide"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h2", _hoisted_6, "Pamplona", 512),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (x, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              "data-slide-title": index
            }, _toDisplayString(x.title), 9, _hoisted_7))
          }), 128)),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, "Lorem Ipsum", 512),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (x, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              "data-slide-status": index,
              ref_for: true,
              ref: "el => { if (el) slideTitleRefs[index] = el }"
            }, _toDisplayString(x.status), 9, _hoisted_10))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (x, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: index,
            src: _ctx.store.dark ? x.imgNight : x.img,
            alt: x.title
          }, null, 8, _hoisted_12))
        }), 128))
      ], 512),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (x, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: index,
            "data-slide": index,
            class: _normalizeClass({ active: index === _ctx.activeSlideId })
          }, null, 10, _hoisted_14))
        }), 128))
      ], 512)
    ], 512)
  ]))
}